import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { allSections } from "@/utils/content";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: '页面不存在 - 17吃瓜网',
    description: '你访问的页面不存在，返回首页继续浏览娱乐区、社会区、科技圈、体育圈与网红圈的最新整理内容。',
    keywords: '17吃瓜网,页面不存在,返回首页',
    path: '/404',
  });

  return (
    <SiteLayout>
      <div className="mx-auto flex w-full flex-col items-center px-4 py-24 text-center md:px-6 md:py-28">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-foreground-500">
          <i className="ri-compass-3-line text-3xl" />
        </span>
        <h1 className="mt-6 font-heading text-3xl font-black text-foreground-950 md:text-4xl">这里没有瓜可吃</h1>
        <p className="mt-3 font-mono text-sm text-foreground-400">{location.pathname}</p>
        <p className="mt-4 text-sm text-foreground-600">
          页面可能已经下线或链接有误，回首页从板块导航重新出发吧。
        </p>

        <Link
          to="/"
          className="mt-7 flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" /> 返回首页
        </Link>

        <div className="mt-8 flex flex-wrap justify-center gap-2">
          {allSections.map((section) => (
            <Link
              key={section.slug}
              to={`/section/${section.slug}`}
              className="flex cursor-pointer items-center gap-1.5 rounded-full border border-background-200 bg-background-100 px-3.5 py-2 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className={section.icon} /> {section.name}
            </Link>
          ))}
        </div>
      </div>
    </SiteLayout>
  );
}